export const showToast = (message: string) => {
  const toast = document.createElement('div');
  toast.className = 'fixed top-4 right-4 bg-green-500 text-white px-4 py-2 rounded shadow-lg z-50';
  toast.textContent = message;
  document.body.appendChild(toast);

  // 3秒后移除toast
  setTimeout(() => {
    toast.remove();
  }, 3000);

  // 移除toast
  toast.addEventListener('click', () => {
    toast.remove();
  });
}

export const showErrorToast = (message: string) => {
  const toast = document.createElement('div');
  toast.className = 'fixed top-4 right-4 bg-red-500 text-white px-4 py-2 rounded shadow-lg z-50';
  toast.textContent = message;
  document.body.appendChild(toast);

  // 3秒后移除toast
  setTimeout(() => {
    toast.remove();
  }, 3000);

  // 移除toast
  toast.addEventListener('click', () => {
    toast.remove();
  });
}
